"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Fullscreen_exports = {};
__export(Fullscreen_exports, {
  default: () => Fullscreen_default
});
module.exports = __toCommonJS(Fullscreen_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.92188 4.41016C2.92188 3.92839 3.09115 3.51823 3.42969 3.17969C3.76823 2.84115 4.17839 2.67188 4.66016 2.67188H8.41016C8.55339 2.67188 8.67057 2.72396 8.76172 2.82812C8.86589 2.91927 8.91797 3.02995 8.91797 3.16016C8.91797 3.30339 8.86589 3.42708 8.76172 3.53125C8.67057 3.6224 8.55339 3.66797 8.41016 3.66797H4.66016C4.45182 3.66797 4.27604 3.73958 4.13281 3.88281C3.98958 4.02604 3.91797 4.20182 3.91797 4.41016V8.16016C3.91797 8.30339 3.86589 8.42708 3.76172 8.53125C3.67057 8.6224 3.55339 8.66797 3.41016 8.66797C3.27995 8.66797 3.16276 8.6224 3.05859 8.53125C2.96745 8.42708 2.92188 8.30339 2.92188 8.16016V4.41016ZM12.082 3.16016C12.082 3.02995 12.1276 2.91927 12.2188 2.82812C12.3229 2.72396 12.4466 2.67188 12.5898 2.67188H16.3398C16.8216 2.67188 17.2318 2.84115 17.5703 3.17969C17.9089 3.51823 18.0781 3.92839 18.0781 4.41016V8.16016C18.0781 8.30339 18.026 8.42708 17.9219 8.53125C17.8307 8.6224 17.7201 8.66797 17.5898 8.66797C17.4466 8.66797 17.3229 8.6224 17.2188 8.53125C17.1276 8.42708 17.082 8.30339 17.082 8.16016V4.41016C17.082 4.20182 17.0104 4.02604 16.8672 3.88281C16.724 3.73958 16.5482 3.66797 16.3398 3.66797H12.5898C12.4466 3.66797 12.3229 3.6224 12.2188 3.53125C12.1276 3.42708 12.082 3.30339 12.082 3.16016ZM3.41016 11.832C3.55339 11.832 3.67057 11.8841 3.76172 11.9883C3.86589 12.0794 3.91797 12.1966 3.91797 12.3398V16.0898C3.91797 16.2982 3.98958 16.474 4.13281 16.6172C4.27604 16.7604 4.45182 16.832 4.66016 16.832H8.41016C8.55339 16.832 8.67057 16.8841 8.76172 16.9883C8.86589 17.0794 8.91797 17.1966 8.91797 17.3398C8.91797 17.4701 8.86589 17.5872 8.76172 17.6914C8.67057 17.7826 8.55339 17.8281 8.41016 17.8281H4.66016C4.17839 17.8281 3.76823 17.6589 3.42969 17.3203C3.09115 16.9818 2.92188 16.5716 2.92188 16.0898V12.3398C2.92188 12.1966 2.96745 12.0794 3.05859 11.9883C3.16276 11.8841 3.27995 11.832 3.41016 11.832ZM17.5898 11.832C17.7201 11.832 17.8307 11.8841 17.9219 11.9883C18.026 12.0794 18.0781 12.1966 18.0781 12.3398V16.0898C18.0781 16.5716 17.9089 16.9818 17.5703 17.3203C17.2318 17.6589 16.8216 17.8281 16.3398 17.8281H12.5898C12.4466 17.8281 12.3229 17.7826 12.2188 17.6914C12.1276 17.5872 12.082 17.4701 12.082 17.3398C12.082 17.1966 12.1276 17.0794 12.2188 16.9883C12.3229 16.8841 12.4466 16.832 12.5898 16.832H16.3398C16.5482 16.832 16.724 16.7604 16.8672 16.6172C17.0104 16.474 17.082 16.2982 17.082 16.0898V12.3398C17.082 12.1966 17.1276 12.0794 17.2188 11.9883C17.3229 11.8841 17.4466 11.832 17.5898 11.832Z",
      fill: "currentColor"
    }
  )
);
const SvgFullscreen = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Fullscreen_default = SvgFullscreen;
